import { render, staticRenderFns } from "./ModalParticipantsGroup.vue?vue&type=template&id=8b600402&scoped=true&"
import script from "./ModalParticipantsGroup.vue?vue&type=script&lang=js&"
export * from "./ModalParticipantsGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalParticipantsGroup.vue?vue&type=style&index=0&id=8b600402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b600402",
  null
  
)

export default component.exports